export type DashboardActionTypes = UpdateDashboardTitleAction;

export const UPDATE_DASHBOARD_TITLE = "UPDATE_DASHBOARD_TITLE";
export interface UpdateDashboardTitleAction {
    type: typeof UPDATE_DASHBOARD_TITLE;
    updateDashboardTitleActionPayload: UpdateDashboardTitleActionPayload;
}

export interface UpdateDashboardTitleActionPayload {
    title: string
};